import React, { useState } from 'react';
import { Form, Button, Card, Row, Col, InputGroup, ButtonGroup, Tab, Nav, Accordion, Spinner } from 'react-bootstrap';

const ToggleSwitch = ({ name, checked, onChange }) => (
  <label className="toggle-switch">
    <input type="checkbox" name={name} checked={checked} onChange={onChange} />
    <span className="slider"></span>
  </label>
);

const MiniCardPreview = (props) => {
  const { cardData, font, layout, orientation, backgroundColor, emphasis, verticalAlign, showLogo } = props;
  const { details, displayOptions } = cardData;
  const [side, setSide] = useState('front');

  const isCompanyEmphasis = emphasis === 'company';
  const showHr = layout === 'h-layout1' || layout === 'v-layout1';
  const headerStyle = (orientation === 'horizontal' && verticalAlign === 'top') ? { alignSelf: 'flex-start' } : { alignSelf: 'center' };
  const contentStyle = (orientation === 'horizontal' && verticalAlign === 'top') ? { alignSelf: 'flex-end' } : { alignSelf: 'center' };

  // 뒷면 영상 처리
  const rawVideoUrl = details.videoUrl;
  const resolvedVideoUrl = (() => {
    if (!rawVideoUrl) return null;
    if (rawVideoUrl.includes('cloudinary.com') && rawVideoUrl.includes('/embed/')) {
      try {
        const u = new URL(rawVideoUrl);
        const cn = u.searchParams.get('cloud_name');
        const pid = u.searchParams.get('public_id');
        if (cn && pid) return `https://res.cloudinary.com/${cn}/video/upload/${pid}.mp4`;
      } catch {}
    }
    return rawVideoUrl;
  })();
  const isVideoFile = resolvedVideoUrl && /\.(mp4|webm|ogg)$/i.test(resolvedVideoUrl);

  const CardFront = (
    <div className={`business-card ${layout} ${orientation}`} data-font={font} data-emphasis={emphasis} data-v-align={verticalAlign} style={{ backgroundColor }}>
      <div className="card-header-section" style={headerStyle}>
        {showLogo && (details.logo
          ? <img src={details.logo} alt="logo" className="card-logo" />
          : <div className="card-logo-placeholder"><svg width="30" height="30" viewBox="0 0 100 100"><rect width="100" height="100" rx="15" fill="#E0E0E0" /></svg></div>
        )}
        <h3 className="card-name">{isCompanyEmphasis ? details.company : details.name}</h3>
        {!isCompanyEmphasis && displayOptions.company && <p className="card-company">{details.company}</p>}
      </div>
      <div className="card-content" style={contentStyle}>
        {isCompanyEmphasis
          ? <p className="card-title">{details.name}{displayOptions.title && <span className="card-title-subtle">, {details.title}</span>}</p>
          : (displayOptions.title && <p className="card-title">{details.title}</p>)
        }
        {showHr && <hr />}
        {displayOptions.phone && <p className="card-contact">{details.phone}</p>}
        {displayOptions.email && <p className="card-contact">{details.email}</p>}
        {displayOptions.website && <p className="card-contact">{details.website}</p>}
        {displayOptions.sns && <p className="card-contact">{details.sns}</p>}
        {displayOptions.address && <p className="card-contact">{details.address}</p>}
      </div>
    </div>
  );

  const CardBack = (
    <div
      className={`business-card back ${orientation}`}
      data-font={font}
      style={{ backgroundColor: resolvedVideoUrl ? '#111' : backgroundColor, position: 'relative', overflow: 'hidden' }}
    >
      {resolvedVideoUrl ? (
        <>
          {isVideoFile ? (
            <video autoPlay muted loop playsInline style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}>
              <source src={resolvedVideoUrl} type="video/mp4" />
            </video>
          ) : (
            <img src={resolvedVideoUrl} alt="bg" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
          )}
          <div style={{ position: 'absolute', inset: 0, background: `rgba(0,0,0,${details.videoOverlay !== '' && details.videoOverlay !== undefined ? parseFloat(details.videoOverlay) : 0.38})`, zIndex: 1 }} />
          <div style={{ position: 'absolute', top: 8, left: 8, right: 8, bottom: 8, border: '1px solid rgba(255,255,255,0.22)', borderRadius: 6, zIndex: 2, pointerEvents: 'none' }} />
          <div style={{ position: 'relative', zIndex: 10, display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center', padding: '16px', textAlign: 'center', flexDirection: 'column' }}>
            {details.engName && (
              <h3 style={{ fontFamily: "'Pinyon Script', cursive", fontSize: '2rem', margin: details.tagline ? '0 0 8px' : '0', color: '#fff', fontWeight: 'normal', lineHeight: 1.2 }}>
                {details.engName}
              </h3>
            )}
            {details.tagline && (
              <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '0.6rem', margin: 0, color: 'rgba(255,255,255,0.85)', letterSpacing: '2.5px', textTransform: 'uppercase' }}>
                {details.tagline}
              </p>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="back-left-panel">
            {showLogo && (
              <div className="card-logo-placeholder-back">
                {details.logo
                  ? <img src={details.logo} alt="logo" className="card-logo-back" />
                  : <svg width="40" height="40" viewBox="0 0 100 100"><rect width="100" height="100" rx="15" fill="#000" fillOpacity="0.05" /></svg>
                }
              </div>
            )}
            <p>{details.company || '회사명'}</p>
          </div>
          <div className="back-right-panel" style={{ fontSize: '0.7em', color: '#aaa', textAlign: 'center' }}>
            <svg width="60" height="60" viewBox="0 0 100 100">
              <rect x="5" y="5" width="30" height="30" fill="none" stroke="#ccc" strokeWidth="4" />
              <rect x="65" y="5" width="30" height="30" fill="none" stroke="#ccc" strokeWidth="4" />
              <rect x="5" y="65" width="30" height="30" fill="none" stroke="#ccc" strokeWidth="4" />
              <rect x="40" y="40" width="20" height="20" fill="#ccc" />
              <rect x="65" y="65" width="30" height="30" fill="none" stroke="#ccc" strokeWidth="4" />
            </svg>
            <div style={{ fontSize: '0.75em', marginTop: 4 }}>QR</div>
          </div>
        </>
      )}
    </div>
  );

  return (
    <div className="mini-preview-container">
      {/* 카드 */}
      <div className={`flip-card ${orientation}`} style={{ cursor: 'default' }}>
        <div className={`flip-card-inner ${side === 'back' ? 'flipped' : ''}`}>
          <div className="flip-card-front">{CardFront}</div>
          <div className="flip-card-back">{CardBack}</div>
        </div>
      </div>

      {/* 영상 배경 시 QR 카드 하단 표시 */}
      {resolvedVideoUrl && side === 'back' && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 12, gap: 4 }}>
          <div style={{ background: '#f5f5f5', borderRadius: 8, padding: 8 }}>
            <svg width="50" height="50" viewBox="0 0 100 100">
              <rect x="5" y="5" width="30" height="30" fill="none" stroke="#333" strokeWidth="6"/>
              <rect x="65" y="5" width="30" height="30" fill="none" stroke="#333" strokeWidth="6"/>
              <rect x="5" y="65" width="30" height="30" fill="none" stroke="#333" strokeWidth="6"/>
              <rect x="42" y="42" width="16" height="16" fill="#333"/>
              <rect x="12" y="12" width="16" height="16" fill="#333"/>
              <rect x="72" y="12" width="16" height="16" fill="#333"/>
              <rect x="12" y="72" width="16" height="16" fill="#333"/>
            </svg>
          </div>
          <span style={{ fontSize: '0.7em', color: '#aaa', letterSpacing: '1px' }}>SCAN TO CONNECT</span>
        </div>
      )}

      {/* 앞/뒷면 토글 */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 14, gap: 0 }}>
        <button
          onClick={() => setSide('front')}
          style={{
            padding: '5px 18px', fontSize: '0.78em', cursor: 'pointer',
            background: side === 'front' ? '#000' : '#fff',
            color: side === 'front' ? '#fff' : '#666',
            border: '1px solid #ddd',
            borderRight: 'none',
            borderRadius: '6px 0 0 6px',
            transition: 'all 0.15s',
          }}
        >앞면</button>
        <button
          onClick={() => setSide('back')}
          style={{
            padding: '5px 18px', fontSize: '0.78em', cursor: 'pointer',
            background: side === 'back' ? '#000' : '#fff',
            color: side === 'back' ? '#fff' : '#666',
            border: '1px solid #ddd',
            borderRadius: '0 6px 6px 0',
            transition: 'all 0.15s',
          }}
        >뒷면</button>
      </div>
    </div>
  );
};

function Editor(props) {
  const { cardData, onDataChange, font, onFontChange, backgroundColor, onBackgroundColorChange, emphasis, onEmphasisChange, verticalAlign, onVerticalAlignChange, showLogo, onShowLogoChange, qrOptions, onQrOptionsChange, layout, onLayoutChange, orientation, onOrientationChange, onNext } = props;
  const { details, displayOptions } = cardData;
  const [isUploading, setIsUploading] = useState(false);

  const handleDetailChange = (e) => onDataChange({ ...cardData, details: { ...details, [e.target.name]: e.target.value } });
  const handleDisplayChange = (e) => onDataChange({ ...cardData, displayOptions: { ...displayOptions, [e.target.name]: e.target.checked } });
  const handleQrOptionChange = (part, key, value) => {
    onQrOptionsChange({
      ...qrOptions,
      [part]: { ...qrOptions[part], [key]: value }
    });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'sample'); // Provided by user

    fetch('https://api.cloudinary.com/v1_1/do1xwqvfh/image/upload', { // Provided by user
      method: 'POST',
      body: formData,
    })
    .then(res => res.json())
    .then(data => {
      onDataChange({ ...cardData, details: { ...details, logo: data.secure_url } });
      setIsUploading(false);
    })
    .catch(err => {
      console.error(err);
      setIsUploading(false);
    });
  };

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'sample');
    const isVideo = file.type.startsWith('video/');
    const endpoint = isVideo
      ? 'https://api.cloudinary.com/v1_1/do1xwqvfh/video/upload'
      : 'https://api.cloudinary.com/v1_1/do1xwqvfh/image/upload';
    fetch(endpoint, { method: 'POST', body: formData })
      .then(res => res.json())
      .then(data => {
        const url = isVideo
          ? `https://res.cloudinary.com/do1xwqvfh/video/upload/${data.public_id}.mp4`
          : data.secure_url;
        onDataChange({ ...cardData, details: { ...details, videoUrl: url } });
        setIsUploading(false);
      })
      .catch(() => setIsUploading(false));
  };

  const fonts = ['Pretendard', 'Noto Sans KR', 'Montserrat', 'Playfair Display'];
  const qrDotTypes = ['dots', 'rounded', 'classy', 'classy-rounded', 'square', 'extra-rounded'];
  const horizontalLayouts = [{ id: 'h-layout1', name: '클래식' }, { id: 'h-layout2', name: '모던' }, { id: 'h-layout3', name: '볼드' }];
  const verticalLayouts = [{ id: 'v-layout1', name: '심플' }];
  const layoutsToShow = orientation === 'horizontal' ? horizontalLayouts : verticalLayouts;

  return (
    <Row>
      <Col md={7}>
        <Tab.Container defaultActiveKey="content">
          <Nav variant="tabs" fill className="mb-3">
            <Nav.Item><Nav.Link eventKey="content">내용</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="design">디자인</Nav.Link></Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="content">
              <Card>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Label>로고</Form.Label>
                    <InputGroup>
                      <Form.Control type="file" accept="image/*" onChange={handleImageUpload} disabled={isUploading} />
                      {isUploading && <InputGroup.Text><Spinner animation="border" size="sm" /></InputGroup.Text>}
                      <InputGroup.Text>
                        <span className="me-2">표시</span>
                        <ToggleSwitch name="showLogo" checked={showLogo} onChange={(e) => onShowLogoChange(e.target.checked)} />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="mb-3"><Form.Label>이름</Form.Label><Form.Control type="text" name="name" value={details.name} onChange={handleDetailChange} /></Form.Group>
                  {Object.keys(displayOptions).map(key => {
                    const labels = { title: '직책', company: '회사명', email: '이메일', phone: '연락처', website: '웹사이트', sns: 'SNS', address: '주소' };
                    if (!labels[key]) return null;
                    return (
                      <Form.Group className="mb-3" key={key}>
                        <Form.Label>{labels[key]}</Form.Label>
                        <InputGroup>
                          <Form.Control type="text" name={key} value={details[key]} onChange={handleDetailChange} disabled={!displayOptions[key]} />
                          <InputGroup.Text><ToggleSwitch name={key} checked={displayOptions[key]} onChange={handleDisplayChange} /></InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    );
                  })}
                </Card.Body>
              </Card>
            </Tab.Pane>
            <Tab.Pane eventKey="design">
              <Accordion>
                <Card><Card.Body>
                  <Form.Group className="mb-3"><Form.Label>강조 방식</Form.Label><div><ButtonGroup><Button variant={emphasis === 'name' ? 'primary' : 'outline-primary'} size="sm" onClick={() => onEmphasisChange('name')}>이름 강조</Button><Button variant={emphasis === 'company' ? 'primary' : 'outline-primary'} size="sm" onClick={() => onEmphasisChange('company')}>회사명 강조</Button></ButtonGroup></div></Form.Group>
                  <Form.Group className="mb-3"><Form.Label>폰트</Form.Label><Form.Select value={font} onChange={(e) => onFontChange(e.target.value)}>{fonts.map(f => <option key={f} value={f}>{f}</option>)}</Form.Select></Form.Group>
                  <Form.Group className="mb-3"><Form.Label>배경색</Form.Label><Form.Control type="color" value={backgroundColor} onChange={(e) => onBackgroundColorChange(e.target.value)} title="배경색 선택" /></Form.Group>
                  <hr />
                  <Form.Group className="mb-3"><Form.Label>방향</Form.Label><div><ButtonGroup><Button variant={orientation === 'horizontal' ? 'primary' : 'outline-primary'} onClick={() => onOrientationChange('horizontal')}>가로형</Button><Button variant={orientation === 'vertical' ? 'primary' : 'outline-primary'} onClick={() => onOrientationChange('vertical')}>세로형</Button></ButtonGroup></div></Form.Group>
                  {orientation === 'horizontal' && <Form.Group className="mb-3"><Form.Label>세로 정렬</Form.Label><div><ButtonGroup><Button variant={verticalAlign === 'center' ? 'primary' : 'outline-primary'} size="sm" onClick={() => onVerticalAlignChange('center')}>중앙</Button><Button variant={verticalAlign === 'top' ? 'primary' : 'outline-primary'} size="sm" onClick={() => onVerticalAlignChange('top')}>상단</Button></ButtonGroup></div></Form.Group>}
                  <Form.Group><Form.Label>레이아웃</Form.Label><Row className="text-center justify-content-center">{layoutsToShow.map(l => (<Col key={l.id} xs={4} className="mb-3"><Card className={`layout-preview-card ${layout === l.id ? 'selected' : ''} ${l.id.startsWith('v-') ? 'vertical' : ''}`} onClick={() => onLayoutChange(l.id)}><Card.Body><div className={`preview-content ${l.id}`}></div></Card.Body></Card><p className="mt-2 small">{l.name}</p></Col>))}</Row></Form.Group>
                </Card.Body></Card>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>뒷면 스타일링</Accordion.Header>
                  <Accordion.Body>
                    <Form.Group className="mb-3">
                      <Form.Label>영문 서명 <span className="text-muted" style={{fontSize:'0.8em'}}>(비워두면 이름 사용)</span></Form.Label>
                      <Form.Control type="text" name="engName" value={details.engName || ''} onChange={handleDetailChange} placeholder="예: Gildong Hong" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>한 줄 소개 / 슬로건 <span className="text-muted" style={{fontSize:'0.8em'}}>(비워두면 직책 사용)</span></Form.Label>
                      <Form.Control type="text" name="tagline" value={details.tagline || ''} onChange={handleDetailChange} placeholder="예: Creating Digital Experiences" />
                    </Form.Group>
                    <hr />
                    <Form.Group className="mb-3">
                      <Form.Label>배경 영상 직접 업로드</Form.Label>
                      <Form.Control type="file" accept="video/*,image/*" onChange={handleVideoUpload} disabled={isUploading} />
                      {isUploading && <div className="mt-2 text-muted" style={{fontSize:'0.85em'}}><Spinner animation="border" size="sm" /> 업로드 중...</div>}
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>배경 영상/이미지 URL</Form.Label>
                      <Form.Control type="url" name="videoUrl" value={details.videoUrl || ''} onChange={handleDetailChange} placeholder="https://res.cloudinary.com/..." />
                      <Form.Text className="text-muted">
                        <strong>허용 URL 형식</strong><br />
                        · Cloudinary CDN: <code style={{fontSize:'0.78em'}}>https://res.cloudinary.com/[cloud]/video/upload/[id].mp4</code><br />
                        · 이미지: <code style={{fontSize:'0.78em'}}>https://res.cloudinary.com/[cloud]/image/upload/[id].jpg</code><br />
                        · 기타 직접 링크: <code style={{fontSize:'0.78em'}}>https://example.com/video.mp4</code><br />
                        <span style={{marginTop:4, display:'block', color:'#888'}}>
                          ☁ Cloudinary 무료: 저장 25GB · 월 전송 25GB (대부분 충분)
                        </span>
                      </Form.Text>
                    </Form.Group>
                    {details.videoUrl && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>어둡기 / 선명도</span>
                            <span className="text-muted" style={{ fontSize: '0.85em' }}>
                              {Math.round((details.videoOverlay !== '' && details.videoOverlay !== undefined ? parseFloat(details.videoOverlay) : 0.38) * 100)}%
                            </span>
                          </Form.Label>
                          <Form.Range
                            min={0} max={90} step={1}
                            value={Math.round((details.videoOverlay !== '' && details.videoOverlay !== undefined ? parseFloat(details.videoOverlay) : 0.38) * 100)}
                            onChange={(e) => onDataChange({ ...cardData, details: { ...details, videoOverlay: (parseInt(e.target.value, 10) / 100).toFixed(2) } })}
                          />
                          <Form.Text className="text-muted" style={{ fontSize: '0.78em' }}>0% = 투명 (원본 선명) · 90% = 거의 검정</Form.Text>
                        </Form.Group>
                        <button
                          type="button"
                          style={{ background: 'none', border: 'none', color: '#999', fontSize: '0.8em', cursor: 'pointer', padding: 0 }}
                          onClick={() => onDataChange({ ...cardData, details: { ...details, videoUrl: '' } })}
                        >
                          × 배경 제거
                        </button>
                      </>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>QR 코드 옵션</Accordion.Header>
                  <Accordion.Body>
                    <Form.Group className="mb-3"><Form.Label>점 모양</Form.Label><Form.Select value={qrOptions.dotsOptions.type} onChange={(e) => handleQrOptionChange('dotsOptions', 'type', e.target.value)}>{qrDotTypes.map(t => <option key={t} value={t}>{t}</option>)}</Form.Select></Form.Group>
                    <Form.Group className="mb-3"><Form.Label>점 색상</Form.Label><Form.Control type="color" value={qrOptions.dotsOptions.color} onChange={(e) => handleQrOptionChange('dotsOptions', 'color', e.target.value)} title="점 색상 선택" /></Form.Group>
                    <Form.Group className="mb-3"><Form.Label>QR 배경색</Form.Label><Form.Control type="color" value={qrOptions.backgroundOptions.color} onChange={(e) => handleQrOptionChange('backgroundOptions', 'color', e.target.value)} title="QR 배경색 선택" /></Form.Group>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        <div className="d-flex justify-content-end mt-4"><Button variant="primary" size="lg" onClick={onNext}>완료 및 공유 &rarr;</Button></div>
      </Col>
      <Col md={5}>
        <h5 className="text-center text-muted mb-3">실시간 미리보기</h5>
        <MiniCardPreview {...props} />
      </Col>
    </Row>
  );
}

export default Editor;


